import { render, staticRenderFns } from "./manage-resultat-tdr.html?vue&type=template&id=08c79ebe&scoped=true&external"
import script from "./manage-resultat-tdr.js?vue&type=script&lang=js&external"
export * from "./manage-resultat-tdr.js?vue&type=script&lang=js&external"
import style0 from "./manage-resultat-tdr.scss?vue&type=style&index=0&id=08c79ebe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c79ebe",
  null
  
)

export default component.exports